<template>
    <breadCrumb/>
    <About/>
</template>

<script>
import breadCrumb from '../components/topSection/topSection.vue'
import About from '../components/about/aboutUs.vue'
export default {
    components: {
        breadCrumb,
        About
    },
    data(){
        return{}
    }
}
</script>
